/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useQuery } from '@apollo/client';
import { isNotNil } from 'es-toolkit';
import { useParams } from 'react-router-dom';

import { DedicatedEndpointVersionInfoDocument } from '@fai/friendli-suite/generated/client/graphql';

export const useEndpointVersionInfo = () => {
  const { endpointId = '' } = useParams();

  const { data: _data, loading } = useQuery(DedicatedEndpointVersionInfoDocument, {
    variables: { endpointId },
    fetchPolicy: 'cache-and-network',
    pollInterval: 1000,
  });

  const currentVersion = _data?.dedicatedEndpoint?.currentVersion;
  const latestVersion = _data?.dedicatedEndpoint?.updatingVersion ?? currentVersion;

  const isUpdateable = isNotNil(currentVersion?.id) && currentVersion.id === latestVersion?.id;

  return { currentVersion, latestVersion, isUpdateable, loading };
};
